import React from "react";
import { FontAwesomeIcon } from "@fortawesome/react-fontawesome";
import { faFilePdf, faFilePowerpoint } from "@fortawesome/free-solid-svg-icons";

function Stage() {
  return (
    <section id="stage" className="my-5 p-5">
      <div className="container">
        {/* Title Section */}
        <h1 className="text-center mb-4 mt-3">
          Stage - Automatiseren van vertalingen en dashboardvisualisaties
        </h1>

        {/* Context Section */}
        <div className="mb-4">
          <h2 className="fw-bold">Context</h2>
          <p>
            Tijdens mijn stage bij <strong>Van Genechten Packaging</strong>{" "}
            werkte ik aan twee interne applicaties die bedrijfsprocessen
            efficiënter en gebruiksvriendelijker maakten. De focus lag op het
            automatiseren van vertalingen en het centraliseren van
            Grafana-dashboards. Deze projecten boden mij de kans om mijn
            technische kennis in de praktijk toe te passen en verder uit te
            breiden.
          </p>
        </div>

        {/* What I Did Section */}
        <div className="mb-4">
          <h2 className="fw-bold">Mijn bijdrage</h2>
          <p>
            Tijdens mijn stage realiseerde ik <strong>twee projecten</strong>:
          </p>

          <ul>
            <li>
              <strong>Vertalingsplatform</strong>: Ik ontwikkelde een oplossing
              waarmee woorden en zinnen automatisch konden worden vertaald naar
              meerdere talen. De vertalingen werden rechtstreeks opgeslagen in
              een centrale database, waardoor het beheer van meertalige content
              eenvoudiger, sneller en consistenter werd. Daarnaast ontwikkelde
              ik een <em>offcanvas-component</em> waarmee gebruikers vertalingen
              konden bekijken, aanpassen en filteren op basis van de
              geselecteerde taal.
            </li>

            <li>
              <strong>Grafana-dashboardplatform</strong>: Naast het
              vertalingsproject ontwikkelde ik een React-applicatie waarin alle
              Grafana-dashboards overzichtelijk werden samengebracht op één
              centrale pagina. Hierdoor kregen gebruikers sneller toegang tot de
              juiste dashboards. Ook voor dit project ontwikkelde ik een{" "}
              <em>offcanvas-component</em> waarmee dashboards gefilterd konden
              worden op omgeving <em>SIT, UAT en PRD</em>. Wanneer er geen
              dashboards beschikbaar waren binnen een gekozen omgeving, werd
              automatisch een link voorzien naar de algemene
              Grafana-overzichtspagina.
            </li>
          </ul>
        </div>

        {/* Outcomes Section */}
        <div className="mb-4">
          <h2 className="fw-bold">Resultaten</h2>
          <p>
            Beide projecten leverden een duidelijke meerwaarde op voor het
            bedrijf:
          </p>

          <ul>
            <li>Sneller en consistenter beheer van vertalingen.</li>
            <li>Betere toegankelijkheid van Grafana-dashboards.</li>
            <li>
              Een overzichtelijke gebruikersinterface dankzij centrale
              filtering.
            </li>
            <li>Minder manuele handelingen en een efficiëntere workflow.</li>
          </ul>
        </div>

        {/* Experience Section */}
        <div className="mb-4">
          <h2 className="fw-bold">Wat ik heb geleerd</h2>
          <p>
            Tijdens deze stage heb ik niet alleen mijn technische vaardigheden
            verder ontwikkeld, maar ook belangrijke professionele competenties
            versterkt.
          </p>

          <ul>
            <li>
              <strong>Communicatie:</strong> actief deelnemen aan en presenteren
              tijdens teammeetings.
            </li>
            <li>
              <strong>Kwaliteitsbewust werken:</strong> code zorgvuldig testen
              en controleren voordat deze naar <strong>GitHub</strong> werd
              gepusht.
            </li>
            <li>
              <strong>Propere code en documentatie:</strong> een duidelijke
              projectstructuur aanbrengen, documentatie onderhouden en onnodige
              code verwijderen om de applicaties overzichtelijk en onderhoudbaar
              te houden.
            </li>
          </ul>
        </div>

        {/* Bewijsstukken Section */}
        <div className="mb-4 p-3 bg-light border rounded">
          <h2 className="fw-bold">Bewijsstukken</h2>
          <p>
            Bekijk hier enkele belangrijke documenten en voorbeelden van mijn
            werk:
          </p>
          <ul className="list-unstyled">
            <li>
              <a
                href="/powerpoint_plan_van_aanpak.pdf"
                target="_blank"
                rel="noopener noreferrer"
                className="btn-link"
              >
                <strong>Plan van aanpak: </strong>
                <FontAwesomeIcon icon={faFilePowerpoint} /> Plan van aanpak
                stage
              </a>
            </li>
            <li>
              <a
                href="/Realisatie_document_stage.pdf"
                target="_blank"
                rel="noopener noreferrer"
                className="btn-link"
              >
                <strong>Realisatie: </strong>
                <FontAwesomeIcon icon={faFilePdf} /> Realisatie documentatie
              </a>
            </li>
            <li>
              <a
                href="/Reflectie_document_stage.pdf"
                target="_blank"
                rel="noopener noreferrer"
                className="btn-link"
              >
                <strong>Reflectie: </strong>
                <FontAwesomeIcon icon={faFilePdf} /> Reflectie over de stage
              </a>
            </li>
          </ul>
        </div>
      </div>
    </section>
  );
}

export default Stage;